import anime from 'animejs'
import { controller, handleReturn, resetForm } from '../form'
import { setCookie, getCookie } from '../util/cookie'

let popup
let close
let form
let content
let escapeLogo
let tick
let excludeUrl
let emailInput
let consent
let separatedArray
let tickAnimation

let tmpTrigger

let controllerObj

export function Popup() {
    popup = document.querySelector('.js-global-popup')
    if (!popup) {
        return
    }

    close = popup.querySelector('.js-global-close')
    form = popup.querySelector('.js-global-form')
    tick = popup.querySelector('.js-global-tick')
    escapeLogo = popup.querySelector('.js-global-escape')
    content = popup.querySelector('.js-global-content')
    excludeUrl = popup.querySelector('#exludeUrl')

    separatedArray = ''

    if (excludeUrl.innerHTML) {
        separatedArray = excludeUrl.innerHTML.split(',')
    }

    if (!separatedArray.includes(window.location.href) && getCookie('popup') !== 'yes') {
        document.querySelectorAll('video').forEach((vid) => vid.pause())
        popup.showModal()
        setCookie('popup', 'yes', 90)
        if (document.querySelector('.popupvideo')) {
            document.querySelector('.popupvideo').play()
        }
    }

    tickAnimation = anime({
        targets: tick,
        strokeDashoffset: [anime.setDashoffset, 0],
        direction: 'reverse',
        easing: 'easeInOutCubic',
        duration: 900
    })

    popup.addEventListener('click', (evt) => {
        if (evt.target.tagName === 'INPUT') {
            return
        }

        if (evt.target.classList.contains('js-global-close')) {
            evt.preventDefault()
            popup.close()
            $('video').each(function () {
                $(this).get(0).play()
            })
            return
        }

        if (
            evt.offsetX < 0 ||
            evt.offsetX > evt.target.offsetWidth ||
            evt.offsetY < 0 ||
            evt.offsetY > evt.target.offsetHeight
        ) {
            popup.close()
        }
    })
}

function toggleTick() {
    if (emailInput.value && consent.checked && !escapeLogo.classList.contains('is-active')) {
        openTick()
    } else if (
        (!emailInput.value || !consent.checked) &&
        escapeLogo.classList.contains('is-active')
    ) {
        closeTick()
    }
}

function closeTick() {
    escapeLogo.classList.remove('is-active')
    tickAnimation.reverse()
    tickAnimation.play()
}

function openTick() {
    escapeLogo.classList.add('is-active')
    tickAnimation.reverse()
    tickAnimation.play()
}
